import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSelectedResource } from '../../actions/orders';
import { customSelectStyles } from '../../utilities/helperUtility';
import Select from '../../components/Common/Select';
import Translation from '../../utilities/localizationUtility';

class Index extends Component {
  onResourcesChange = this.onResourcesChange;

  UNSAFE_componentWillReceiveProps(newProps) {
    const { resources } = newProps;
    const { onSelectedResource, selectedResource } = this.props;
    if (!resources) {
      if (selectedResource != null) {
        onSelectedResource(null);
      }
    }
  }

  onResourcesChange(id) {
    const { resources, onSelectedResource } = this.props;
    const currentResource = resources.find(resource => resource.id === id);

    if (id == null) {
      onSelectedResource(null);
    } else if (currentResource) {
      onSelectedResource(currentResource);
    }
  }

  resourceOptions() {
    const { resources } = this.props;

    return resources.map(({ name, id }) => ({
      label: name,
      value: id,
    }));
  }

  placeholder() {
    const t = new Translation(this.props);
    return t.key('resourceDropdownPrompt') || 'Select Resource...';
  }

  render() {
    const { selectedResource, styles, className } = this.props;
    const resourceOptions = this.resourceOptions();
    
    if (!resourceOptions.length) return null;

    const selectedResourceId = selectedResource ? selectedResource.id : null;

    return (
      <Select
        placeholder={this.placeholder()}
        styles={styles}
        className={className}
        name="resources"
        value={selectedResourceId}
        options={resourceOptions}
        isClearable
        isSearchable={false}
        allowSelectOption
        onChange={x => this.onResourcesChange(x)}
      />
    );
  }
}

export default connect(
  ({ 
    product, 
    order, 
    settings: { 
      style = {}, 
      translation = {}, 
      defaultTranslation = {} 
    } 
  }) => ({
    resources: product.data.resources,
    selectedResource: order.selectedResource,
    styles: customSelectStyles(style.select),
    translation: translation,
    defaultTranslation: defaultTranslation
  }),
  dispatch => ({
    onSelectedResource: a => dispatch(setSelectedResource(a)),
  }),
)(Index);
